export { default as LogoCarasso } from './LogoCarasso'
export { default as LogoDanielNina } from './LogoDanielNina'
export { default as LogoMakesense } from './LogoMakesense'
export { default as ColoredDiamond } from './ColoredDiamond'
